import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/text-logo.png'
import _imports_1 from '../assets/seattle.png'


const _withScopeId = n => (_pushScopeId("data-v-01abf7dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "video-wrap",
  id: "homevid1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  "data-bg": "",
  class: "bgimg",
  src: "https://seattleyachtmedia.b-cdn.net/arial.png",
  alt: "../assets/arial.png"
}
const _hoisted_5 = {
  key: 1,
  preload: "none",
  autoplay: "",
  muted: "",
  playsinline: "",
  loop: "",
  poster: "https://seattleyachtmedia.b-cdn.net/arial.png"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://seattleyachtmedia.b-cdn.net/arial.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_7 = {
  class: "video-wrap",
  id: "homevid2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  "data-bg": "",
  class: "bgimg",
  src: "https://seattleyachtmedia.b-cdn.net/bridge.png",
  alt: "../assets/bridge.png"
}
const _hoisted_11 = {
  key: 1,
  preload: "none",
  autoplay: "",
  muted: "",
  playsinline: "",
  loop: "",
  poster: "https://seattleyachtmedia.b-cdn.net/bridge.png"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://seattleyachtmedia.b-cdn.net/bridge.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_13 = { class: "page-content" }
const _hoisted_14 = { class: "text-cards" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: "video-wrap",
  id: "homevid3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  "data-bg": "",
  class: "bgimg",
  src: "https://seattleyachtmedia.b-cdn.net/couple.png",
  alt: "../assets/couple.png"
}
const _hoisted_20 = {
  key: 1,
  preload: "none",
  autoplay: "",
  muted: "",
  playsinline: "",
  loop: "",
  poster: "https://seattleyachtmedia.b-cdn.net/couple.png"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://seattleyachtmedia.b-cdn.net/couple.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_22 = { class: "page-content" }
const _hoisted_23 = { class: "text-cards" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = {
  class: "video-wrap",
  id: "homevid4"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  "data-bg": "",
  class: "promo-page-background",
  src: "https://seattleyachtmedia.b-cdn.net/seattle.png",
  alt: "../assets/seattle.png"
}
const _hoisted_29 = {
  key: 1,
  preload: "none",
  autoplay: "",
  muted: "",
  playsinline: "",
  loop: "",
  class: "promo-page-background",
  poster: _imports_1
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://seattleyachtmedia.b-cdn.net/seattle.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_31 = { class: "page-content" }
const _hoisted_32 = { id: "image-box-row" }
const _hoisted_33 = { class: "image-boxes" }
const _hoisted_34 = { class: "home-social" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactCard4 = _resolveComponent("ContactCard4")!
  const _component_ContactCard2 = _resolveComponent("ContactCard2")!
  const _component_ScrollIndicator = _resolveComponent("ScrollIndicator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-logo-bottom instant-div", { 'active': _ctx.activeScrollIndex === 0 }])
      }, _hoisted_3, 2),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : (_openBlock(), _createElementBlock("video", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" Your browser does not support HTML5 video. ")
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-logo-top instant-div", { 'active': _ctx.activeScrollIndex === 1 }])
      }, _hoisted_9, 2),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
        : (_openBlock(), _createElementBlock("video", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(" Your browser does not support HTML5 video. ")
          ])),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["text-card right delay-div", { 'active': _ctx.activeScrollIndex === 1 }])
          }, [
            _createTextVNode(" adventures are how "),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("br", _hoisted_15))
              : _createCommentVNode("", true),
            _createTextVNode("we make our moments ")
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-logo-bottom delay-div", { 'active': _ctx.activeScrollIndex === 2 }])
      }, _hoisted_18, 2),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("img", _hoisted_19))
        : (_openBlock(), _createElementBlock("video", _hoisted_20, [
            _hoisted_21,
            _createTextVNode(" Your browser does not support HTML5 video. ")
          ])),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: _normalizeClass(["text-card left instant-div", { 'active': _ctx.activeScrollIndex === 2 }])
          }, [
            _createTextVNode(" stories are how "),
            _hoisted_24,
            _createTextVNode("we share them ")
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-logo-bottom delay-div8", { 'active': _ctx.activeScrollIndex === 3 }])
      }, _hoisted_27, 2),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("img", _hoisted_28))
        : (_openBlock(), _createElementBlock("video", _hoisted_29, [
            _hoisted_30,
            _createTextVNode(" Your browser does not support HTML5 video. ")
          ])),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/channel/UCU7PhHxisyz2ipQZ1p6G-Hg",
              target: "_blank",
              class: _normalizeClass(["instant-div promo-image-box", { 'active': _ctx.activeScrollIndex === 3 }])
            }, null, 2),
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=xBaTvwYiwtI&t=2s",
              target: "_blank",
              class: _normalizeClass(["delay-div1 promo-image-box", { 'active': _ctx.activeScrollIndex === 3 }])
            }, null, 2),
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=xBaTvwYiwtI&t=2s",
              target: "_blank",
              class: _normalizeClass(["delay-div2 promo-image-box", { 'active': _ctx.activeScrollIndex === 3 }])
            }, null, 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("a", {
            target: "_blank",
            href: "https://www.facebook.com/people/Seattle-Yacht-Media/100070387113379/?paipv=0&eav=AfYVhKY3RYg0WB43LbE1VEzzCWfVAgkpbzd2X0dWXieiUl_7THUEtOg4DWp3E00Tmp8&_rdr",
            class: _normalizeClass(["delay-div3 fa fa-facebook", { 'active': _ctx.activeScrollIndex === 3 }])
          }, null, 2),
          _createElementVNode("a", {
            href: "https://www.instagram.com/seattleyachtmedia/",
            target: "_blank",
            class: _normalizeClass(["delay-div4 fa fa-instagram", { 'active': _ctx.activeScrollIndex === 3 }])
          }, null, 2),
          _createElementVNode("a", {
            target: "_blank",
            href: "https://www.youtube.com/channel/UCU7PhHxisyz2ipQZ1p6G-Hg",
            class: _normalizeClass(["delay-div5 fa fa-youtube", { 'active': _ctx.activeScrollIndex === 3 }])
          }, null, 2),
          _createElementVNode("a", {
            target: "_blank",
            href: "https://www.linkedin.com/company/seattle-yacht-media/",
            class: _normalizeClass(["delay-div6 fa fa-linkedin", { 'active': _ctx.activeScrollIndex === 3 }])
          }, null, 2)
        ])
      ]),
      _createVNode(_component_ContactCard4, {
        class: "delay-div",
        "active-scroll-index": _ctx.activeScrollIndex
      }, null, 8, ["active-scroll-index"]),
      _createVNode(_component_ContactCard2, {
        class: "delay-div",
        "active-scroll-index": _ctx.activeScrollIndex
      }, null, 8, ["active-scroll-index"])
    ]),
    _createVNode(_component_ScrollIndicator, { activeIndex: _ctx.activeScrollIndex }, null, 8, ["activeIndex"])
  ], 64))
}